<template>
  <div class="results-header-card">
    <div class="results-header-content">
      <div class="results-header-left">
        <div class="results-header-mainline">
          <h2 class="results-title">Comparador de Seguros</h2>
          <div class="progress-indicator-compact">
            <div class="progress-step-compact">
              <div class="progress-circle progress-circle-completed">
                <el-icon>
                  <Check />
                </el-icon>
              </div>
              <span class="progress-label progress-label-active">Vehículo</span>
            </div>
            <div class="progress-line progress-line-active"></div>
            <div class="progress-step-compact">
              <div class="progress-circle progress-circle-active">2</div>
              <span class="progress-label progress-label-active">Resultados</span>
            </div>
          </div>
        </div>
      </div>
      <el-button circle size="default" @click="emit('close')" class="results-close-button" title="Cerrar">
        <el-icon>
          <Close />
        </el-icon>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Check, Close } from '@element-plus/icons-vue';

const emit = defineEmits<{
  close: [];
}>();
</script>

